export const DEFAULT_NUM_RESULTS = 6;
export const DEFAULT_NUM_MAP_RESULTS = 16;
export const NUM_MAP_VIEW_LISTED_STORES = 1;
export const ACTIVE_MARKER_ICON =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20210322-f8bd6-dc033?wid=32&hei=32&fmt=png-alpha';
export const INACTIVE_MARKER_ICON =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20210322-d4c55-06b16?wid=32&hei=32&fmt=png-alpha';
export const DISTANCE = 'distance';
export const DEALER_NAME = 'dealerName';
export const MILLISECONDS_DEBOUNCE = 300;
export const CLOSED = 'Closed';
export const OPEN_24_HOURS = 'Open 24 hours';
export const DEFAULT_MAP_ZOOM = 6;
export const SELECTED_STORE_ID = 'selectedStoreId';
export const TERMS_CHECKED = 'termsChecked';
export const SORT_ORDER = 'sortOrder';
export const OPTIONS = 'options';
export const DEALER_LOCATOR_FILTERS_DRAWER = 'dealer-locator-filters-drawer';
export const DEALER_LOCATOR_EVENT_NAME = 'Dealer Locator';
export const SELECT_STORE = 'Select Store';
export const FORM_LOCATION_HOMEPAGE = 'homepage';
